import { convertibleFromObject, queryParamsFromObject } from './helpers';
import { ServerModel, FitmentFieldValues } from './types/types';

export const apiVersion = API_VERSION;

const commonRequestExtra = { apiVersion };

async function searchByVehicle(
  storeId: string,
  vehicle: Record<string, string>,
  options?: { page?: number; pageSize?: number },
): Promise<ServerModel.GenericItem[]> {
  const baseUrl = `https://${storeId}.myconvermax.com/search.json`;

  const queryParams: Record<string, Record<string, string> | string> = {};

  if (options?.page !== undefined) {
    queryParams.page = options.page.toString();
  }
  if (options?.pageSize !== undefined) {
    queryParams.pageSize = options.pageSize.toString();
  }

  Object.entries(vehicle).forEach(([key, value], index) => {
    queryParams[`facet.${index}.field`] = key;
    queryParams[`facet.${index}.selection`] = value;
  });

  const extra = { ...commonRequestExtra };
  queryParams.extra = convertibleFromObject(extra);

  const url = `${baseUrl}?${queryParamsFromObject(queryParams)}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data.Items ?? [];
  } catch (error) {
    console.error('Error fetching products:', error);
    return [];
  }
}

async function getFitments(storeId: string, productId: string): Promise<ServerModel.FitmentsResponseType> {
  const baseUrl = `https://${storeId}.myconvermax.com/ymm/fitments.json`;

  const queryParams: Record<string, Record<string, string> | string> = {
    productId: encodeURIComponent(productId),
  };

  const extra = { ...commonRequestExtra };
  queryParams.extra = convertibleFromObject(extra);

  const url = `${baseUrl}?${queryParamsFromObject(queryParams)}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data as ServerModel.FitmentsResponseType;
  } catch (error) {
    console.error('Error fetching fitments:', error);
    return {
      Fitment: FitmentFieldValues.NoFitmentData,
      Fields: null,
      Fitments: null,
    };
  }
}

// Export named functions for ESM imports
export { searchByVehicle, getFitments };

// Export as default for UMD compatibility
export default {
  searchByVehicle,
  getFitments,
};
